import { permissionsRol as settingsRol } from 'app/policies/roles/settingsRol.access';
import { PATH_SETTINGS, PATH_SETTINGS_COUNTRIES, PATH_SETTINGS_LEARNING_OBJECTIVES, PATH_SETTINGS_SCALES } from 'app/router/routesConfigSetting';
import store from 'app/store/store';

export function onClickButtonSettings(history, user) {
  const storeRedux = store.getState();
  const { is_multicountry } = storeRedux['system-setting'].settings;

  if (settingsRol(user).generalSettings) {
    history.push(PATH_SETTINGS);
    return;
  }

  if (settingsRol(user).countriesSettings && is_multicountry) {
    history.push(PATH_SETTINGS_COUNTRIES);
    return;
  }

  if (settingsRol(user).learningObjectivesSettings) {
    history.push(PATH_SETTINGS_LEARNING_OBJECTIVES);
    return;
  }

  if (settingsRol(user).scalesSettings) {
    history.push(PATH_SETTINGS_SCALES);
  }
}
